import { globalActions } from "@/containers/global/slice";
import { setAuthFailureHandler } from "@/shared/providers/authBridge";
import { configureAppStore } from "./configureStore";

export const store = configureAppStore();

// The API client cannot import the store (the saga graph imports the client,
// so it would be a cycle). It reports auth failures through this bridge
// instead, and one action drives every logout path.
setAuthFailureHandler(() => {
  store.dispatch(globalActions.logOut());
});

export type { AppDispatch, AppStore } from "./configureStore";
export type { RootState } from "./types";
